import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react'
import { useDispatch } from 'react-redux'
import { updatePhaseExpanded } from 'redux/slices/activeWorkoutV5'

export default function PhaseHeaderV5({ 
    workoutId,
    phaseIndex,
    phase 
}) {
    const dispatch = useDispatch()

    const TogglePhaseExpanded = () => {
        const payload = {
            workoutId: workoutId,
            phaseIndex: phaseIndex,
            value: !phase.expanded
        }

        dispatch(updatePhaseExpanded(payload))
    }

    const phaseSlotCount = phase?.slots?.length ?? 0
    const phaseSetCount = phase?.sets ?? 0

    return (
        <div 
            className="p-4 gap-x-6 flex items-center border-b border-gray-200 cursor-pointer"
            onClick={TogglePhaseExpanded}
        >
            <h2 className='text-2xl font-normal flex-grow select-none'>
                {phase.name}
            </h2>

            <p className='text-gray-600 select-none'>
                {phaseSlotCount} exercise{phaseSlotCount > 1 ? 's' : ''}
            </p>

            {phase.type === 'circuit' && (
                <p className='text-gray-600 select-none'>
                    {phaseSetCount} set{phaseSetCount > 1 ? 's' : ''}
                </p>
            )}

            {phase.expanded && <ChevronsDownUp className="h-6 w-6 text-gray-500" />}

            {!phase.expanded && <ChevronsUpDown className="h-6 w-6 text-gray-500" />}
        </div>
    )
}